import 'styled-components/macro';
import React from 'react';
import { useTheme, Typography } from '@harver/shared-ui';

import { ContentCard } from '../../components/ContentCard';
import { useContent } from '../../branding/content.context';
import CookieBanner from '../../components/CookieBanner';

export function Confirmation() {
    const theme = useTheme();
    const { interviewUnavailable: LANG } = useContent();

    document.title = LANG.thankYouPage.title;

    return (
        <>
            <ContentCard>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                        testId="unavailable.message.confirmation"
                    >
                        {LANG.thankYouPage.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                        }}
                        variant="body2"
                    >
                        {LANG.thankYouPage.message}
                    </Typography>
                </div>
                <CookieBanner />
            </ContentCard>
        </>
    );
}
